import { Cancel, Create } from '@mui/icons-material';
import { MenuItem, Stack, SvgIcon, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { DataColumn } from '../../../types';
import DraggableColumn from '../../sidebar/columns/DraggableColumn';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const DataColumnDraggable: FunctionComponent<{
  item: DataColumn;
  index: number;
  onEdit: (item: DataColumn) => void;
  onRemove: (item: DataColumn) => void;
  disabled?: boolean;
}> = ({ item, index, onEdit, onRemove, disabled }) => {
  const { tag, aggregation, id } = item;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
  };
  return (
    <div ref={setNodeRef} style={style}>
      <DraggableColumn
        id={id}
        dragHandleProps={disabled ? {} : { ...attributes, ...listeners }}
        renderContextItems={
          disabled
            ? undefined
            : () => (
                <>
                  <MenuItem onClick={() => onEdit(item)}>
                    <Stack alignItems="center" gap="2px" flexDirection="row">
                      <SvgIcon component={Create} />
                      <Typography variant="body2">Edit</Typography>
                    </Stack>
                  </MenuItem>
                  <MenuItem onClick={() => onRemove(item)}>
                    <Stack alignItems="center" gap="2px" flexDirection="row">
                      <SvgIcon color="error" component={Cancel} />
                      <Typography color="error" variant="body2">
                        Remove
                      </Typography>
                    </Stack>
                  </MenuItem>
                </>
              )
        }
      >
        <Typography fontWeight="600" color="primary" variant="body2">
          {tag?.siteName} {tag?.tagName} -{' '}
          {aggregation?.label === 'undefined' ? '' : aggregation?.label}
        </Typography>
      </DraggableColumn>
    </div>
  );
};

export default DataColumnDraggable;
